import { render, staticRenderFns } from "./YesButton.vue?vue&type=template&id=35e59cf0&scoped=true&"
import script from "./YesButton.vue?vue&type=script&lang=js&"
export * from "./YesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e59cf0",
  null
  
)

export default component.exports